var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "number-range"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "value": _vm.min
    },
    on: {
      "input": _vm.handleMin
    }
  }), _vm._v(" - "), _c('el-input', {
    attrs: {
      "type": "number",
      "value": _vm.max
    },
    on: {
      "input": _vm.handleMax
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };